import { module as Module } from 'modujs'
import * as THREE from 'three';
import { OrbitControls } from '../classes/explore/OrbitControls.js' 
import { $screen } from '../stores/screen.js';

export default class extends Module {
    constructor(m) {
        super(m)

        this.canvas = this.el;
        this.orbitDomElement = this.canvas;

        this.resize();
        this.unbindScreenListener = $screen.subscribe(this.resize.bind(this))
    }

    init() {
        this.initRenderer();
        this.initScene();
        this.resize();

        this.render();
    }

    initRenderer() {
        this.renderer = new THREE.WebGLRenderer({
            canvas: this.canvas,
            alpha: true,
            antialias: true,
            preserveDrawingBuffer: true // for screenshots
        })

        this.renderer.setSize(this.sizes.width, this.sizes.height)
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

        this.clock = new THREE.Clock()
        this.previousTime = 0
    }

    initScene() {        
        // ==========================================================================
        // BASIS
        // ==========================================================================
        this.scene = new THREE.Scene();

        // Wrapper
        this.wrapper = new THREE.Group();
        this.wrapper.position.set(0,0,0);
        this.scene.add(this.wrapper)

        // ==========================================================================
        // CAMERA
        // ==========================================================================

        // Base camera
        this.camera = new THREE.PerspectiveCamera(30, this.sizes.width / this.sizes.height, 0.01,100)
        this.camera.position.set(4,0,4)
        this.scene.add(this.camera);

        this.renderingCamera = this.camera;        

        // Controls
        this.controls = new OrbitControls(this.camera, this.orbitDomElement)        
    }

    resize() {
        this.BCR = this.el.getBoundingClientRect()

        this.sizes = {
            width: this.BCR.width,
            height: this.BCR.height
        }

        this.renderer?.setSize?.(this.sizes.width, this.sizes.height);
        this.renderer?.setPixelRatio?.(Math.min(window.devicePixelRatio, 2))

        if(this.renderingCamera) {
            // Update default camera for raycasting, etc.
            this.camera.aspect = this.sizes.width / this.sizes.height
            this.camera.updateProjectionMatrix()

            // Update rendering camera if different
            if(this.renderingCamera != this.camera) {
                this.renderingCamera.aspect = this.sizes.width / this.sizes.height
                this.renderingCamera.updateProjectionMatrix()
            }
        }
    }

    onRender() {}

    render() {
        const elapsedTime = this.clock.getElapsedTime()
        this.deltaTime = elapsedTime - this.previousTime
        this.previousTime = elapsedTime

        // Update controls
        this.controls.update()

        this.onRender();

        // Render
        this.renderer.render(this.scene, this.renderingCamera);

        // Call tick again on the next frame
        this.raf = window.requestAnimationFrame(this.render.bind(this))
    }

    destroy() {
        this.controls.dispose()        

        this.unbindScreenListener?.();
        window.cancelAnimationFrame(this.raf)
        this.scene = this.renderer = null
    }
}